/*
 * Show "SALE" for variants swatch imgs
 * Implemented: sections/main-product.liquid and assets/custom-async.js.liquid 4411-4414
 */
function initVariantSwatchesSale(){

  const productData = document.querySelector("script#product-bagde-data").innerHTML;  

  if(!productData){
    return console.log("Variants swatchs sale, Can not found product data script")
  }

  //console.log("data", JSON.parse(productData))
  //const filteredProducts = parsedData.variants.filter(v => (v.compare_price !== 0 && v.price < v.compare_price) )
  const parsedData = JSON.parse(productData)
  const filteredProducts = parsedData.variants.filter(v => ((v.compare_price !== 0) && (v.price !== v.compare_price)) )
  //console.log("filteredProducts", filteredProducts)

  if(filteredProducts.length === 0){
   return console.log("Variants swatchs sale, no products with sale")
  }

  const saleProductTitles = filteredProducts.map(v => v.options[0])
  
  if(saleProductTitles.length === 0){
   return console.log("Variants swatchs sale, no products sale title")
  }

  const titles =  [...new Set(saleProductTitles)]
  
  if(titles.length === 0){
   return console.log("Variants swatchs sale, no products sale unique title")
  }

  //console.log("titles", titles)
  
  titles.forEach(title => {
    const element = document.querySelector(`[data-js-swatch='${title}']`)
    
    if(!element){
      return console.log("Variants swatchs sale, cant found DOM swatch element", title)
    }

    //console.log("title", element)
    element.classList.add("is-sale-variant")
  }) 
}
// first load
initVariantSwatchesSale()

// variant onChange
// implemented -> assets/custom-async.js.liquid 4411-4414
window.initVariantSwatchesSale = initVariantSwatchesSale